import axios from "axios";
import { base_url } from "../../constants";
import { message } from "antd";
import { getContractedUser } from "../../utils/Helper";

export const uploadReview = async (payload, setLoading, navigate, intl) => {
  const { data, review, rating, contract } = payload;
  const token = JSON.parse(localStorage.getItem("data"));
  const { user_contracted_type, id } = getContractedUser(
    token?.user_type,
    contract
  );
  // A standard (non-subcontract) contract has no parent. FormData.append coerces a
  // null/undefined value to the literal string "null", which the backend then fails to
  // cast to an integer ("invalid input syntax for type integer: null"). Only append it
  // when there's a real numeric parent id; otherwise omit the field entirely.
  const parentContractId =
    typeof contract?.parentContractId === "string"
      ? null
      : contract?.parentContractId;

  const formData = new FormData();
  data.map((item) => formData.append("images", item));
  formData.append("comment", review);
  formData.append("stars", rating);
  formData.append("type", token?.user_type);
  formData.append("user_contracted_type", user_contracted_type);
  formData.append("contract_id", contract?.id);
  if (parentContractId != null) {
    formData.append("parentContractId", parentContractId);
  }
  formData.append(`${token?.user_type}Id`, token?.id);
  formData.append(`${user_contracted_type}Id`, id);

  try {
    setLoading(true);
    await axios
      .post(`${base_url}message-files/reviews`, formData, {
        headers: {
          Authorization: `Bearer ${token?.accessToken}`,
          "ngrok-skip-browser-warning": true,
        },
      })
      .then((response) => {
        message.success(`${intl.formatMessage({ id: "review_submitted" })}`);
        setLoading(false);
        navigate("/");
      })
      .catch((error) => {
        setLoading(false);
        const errorMessage = error.response.data.message;
        message.error(errorMessage);
      });
  } catch (error) {
    message.error(`${intl.formatMessage({ id: "something_went_wrong" })}`);
  }
};
